module.exports = __webpack_public_path__ + "img/gz_transaction_card_more.c53e3212.png";